export { default as reducer } from './reducer';
export { default as router } from './routes';
export const name = 'apps';
